<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <div class="line"></div>
            <div class="info bv bc fz_30">
                <div class="bh bc">
                    <div class="ico ico-win bg-contain"></div>
                    <div class="fz_40 lh1_5 tc">支付成功</div>
                </div>
                <div class="bh text fz_30">实付金额：{{params.price}}{{unitName}}</div>
                <div class="bh bc button">
                    <van-button class="btn btn-look-big" @click="replaceGo('ShopHome')">返回首页</van-button>
                    <van-button class="btn btn-submit-big" @click="goOrder">订单详情</van-button>
                </div>
            </div>
            <div class="titlebg fz_30 tc bg-contain">宝贝推荐</div>
            <CarGoods :data="store.data" :isReplace="true"></CarGoods>
        </div>
    </div>
</template>
<script>
import { routeCache } from "@/mixin/cache";
import { user } from "@/mixin/user";
import { ordreEndRecommend } from "@/api/cart";
import CarGoods from "@/views/car/goods/Item";
import store from "@/utils/store";
export default {
    mixins: [routeCache, user],
    name: "CartOrderConsequence",
    components: { CarGoods },
    data() {
        return {
            unitName: "",
            params: {},
            store: {
                data: [],
                proxy: {
                    getList: ordreEndRecommend
                }
            }
        };
    },
    methods: {
        goOrder() {
            const me = this;
            let id = me.params.orderId;
            if (!id) {
                id = me.$store.state.cart.orderId;
                if (!id) {
                    me.dialog.alert({ title: "提示", message: `订单id不存在` });
                }
            }
            me.replaceGo("CartOrderInfo", { id: id });
        },
        userLoginend() {
            const me = this,
                params = me.getCache();
            store.load(me.store);
            // 如果找不到订单id
            if (!params.orderId) {
                // 从store中取出orderId
                params.orderId = me.$store.state.cart.orderId;
                // 重新缓存数据
                me.setCache(params);
            }
            me.params = params;
            me.unitName = params.isWeiXin ? "元" : "车主币";
        }
    }
};
</script>
<style scoped lang="scss">
.topbar-container {
    background-color: #f1f2f3;
    .info {
        background: #fff;
        padding: 60px 0 56px 0;
        .ico {
            width: 51px;
            height: 51px;
            margin-right: 11px;
        }
        .text {
            padding: 35px 0;
        }
        .money {
            color: #ff9a2b;
        }
        .line {
            background: #f1f2f3;
        }
    }
    .button {
        .btn {
            width: 180px;
            margin-top: 0;
        }
        .btn-look-big {
            margin-right: 10px;
        }
        .btn-submit-big {
            margin-left: 10px;
        }
    }
    .titlebg {
        margin: 60px 20% 10px 20%;
    }
    .shop-list {
        padding: 0 20px 40px 20px;
    }
}
</style>
